import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import renderCalendar from "../Calendar";
import renderDropdown from "../DropDownCustom"; 
import renderInputNumber from "../InputCustom";
import styles from "./index.module.css";
import IDropDownOption from '../../interfaces/IDropDowmOption';
import { useTranslation } from 'react-i18next'; 

interface FiltersByEventProps {
    startDate: Date | null; 
    endDate: Date | null;
    selectedOption: boolean | null;
    inputValue: string | null;
    setStartDate: (date: Date | null) => void;
    setEndDate: (date: Date | null) => void;
    setSelectedOption: (option: boolean | null) => void;
    setInputValue: (value: string | null) => void;
    applyFilters: () => void;
    resetFilters: () => void;
}

const FiltersByEvent: React.FC<FiltersByEventProps> = ({
    startDate,
    endDate,
    selectedOption,
    inputValue,
    setStartDate,
    setEndDate,
    setSelectedOption,
    setInputValue,
    applyFilters,
    resetFilters
}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedDropdownValue, setSelectedDropdownValue] = useState<IDropDownOption | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { t: translateGeneral } = useTranslation("general");
    const { t: translateForm } = useTranslation("form");

    useEffect(() => {
        setIsLoading(false);
        if (selectedOption !== null) {
            const option = dropdownOptions.find(opt => opt.boolean === selectedOption);
            setSelectedDropdownValue(option || null);
        } else {
            setSelectedDropdownValue(null);
        }
    }, [selectedOption]);

    const toggleFilters = (): void => {
        setIsOpen(prev => !prev);
    };

    const dropdownOptions: IDropDownOption[] = [
        { id: 1, description: "Ok", boolean: true },
        { id: 2, description: "Não Ok", boolean: false }
    ];

    const handleDropdownChange = (e: { value: IDropDownOption | null }): void => {
        setSelectedDropdownValue(e.value);
        setSelectedOption(e.value ? e.value.boolean : null);
    };

    return (
        <div className={styles.filtersContainer}>
            <Button
                onClick={toggleFilters}
                label={isOpen ? translateGeneral("collectFilter") : translateGeneral("filter")}
                className={`${styles.submit} ${styles.toggleButton}`}
            />
            {isOpen && (
                <div className={styles.filters}>
                    {renderCalendar(
                        translateForm("initDate"),
                        (e) => setStartDate(e.value),
                        startDate,
                        false, 
                        "initDate"
                    )}
                    {renderCalendar(
                        translateForm("finalDate"),
                        (e) => setEndDate(e.value),
                        endDate,
                        false, 
                        "endDate"
                    )}
                    {renderDropdown(
                        dropdownOptions,
                        translateForm("result"),
                        handleDropdownChange,
                        selectedDropdownValue,
                        false,
                        isLoading 
                    )}
                    {renderInputNumber(
                        {
                            label: "Acurácia",
                            value: inputValue,
                            onChange: setInputValue,
                            isDisabled: false,
                            placeholder:"%"
                        }
                    )}
                    <Button 
                        label={translateGeneral("filter")}
                        onClick={applyFilters} 
                        className={`${styles.submit} ${styles.toggleButton}`}
                    />
                    <Button 
                        label={translateGeneral("clear")}
                        onClick={resetFilters} 
                        className={`${styles.submit} ${styles.toggleButton}`}
                    />
                </div>
            )}
        </div>
    );
};

export default FiltersByEvent;
